<template>
  <hic-list-page ref="listPage" title="医嘱模板" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" header-height="3rem" keyword-placeholder="模板名称、关键字">
    <template slot="buttons">
      <!-- <el-button type="primary" size="mini" icon="el-icon-document-add" @click="edit(null)">新增</el-button> -->
      <el-radio-group v-model="condition.scope" @input="page" style="margin-left: 10px">
        <el-radio label="本人">本人</el-radio>
        <el-radio label="本科">本科</el-radio>
        <el-radio label="全院">全院</el-radio>
      </el-radio-group>
    </template>
    <template slot="search">
      <el-checkbox v-model="isMine" style="margin-right: 1rem" @change="page">我的</el-checkbox>
      <el-date-picker @change="changeDate" style="width: 270px" size="small" v-model="date" type="daterange" range-separator="至" start-placeholder="创建日期" end-placeholder="结束日期"></el-date-picker>

      <!-- <el-date-picker class="left-pad condition-input" size="small" v-model="condition.date" type="date" placeholder="日期"></el-date-picker> -->
    </template>
    <el-table-column align="center" label="操作" width="120">
      <template slot-scope="{ row }">
        <div v-if="isMyTmpl(row)">
          <el-button @click.native="edit(row)" type="primary" size="mini" icon="el-icon-edit" circle plain></el-button>
          <el-button @click.native="del(row)" type="danger" size="mini" icon="el-icon-delete" circle plain></el-button>
        </div>
      </template>
    </el-table-column>
    <el-table-column  label="模板名称" prop="title" ></el-table-column>
    <el-table-column align="center" label="模板范围" prop="scope" width="100"></el-table-column>
    <el-table-column align="left" label="关键字" prop="keyword"></el-table-column>
    <el-table-column align="left" label="备注" prop="memo"></el-table-column>
    <el-table-column align="center" label="创建人" prop="doctorName" width="150"></el-table-column>
    <el-table-column align="center" label="科室" prop="deptCode" width="150">
      <template slot-scope="{ row }">
        <div>{{ row.deptCode | dictText("Dept") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="创建时间" prop="no" width="100">
      <template slot-scope="{ row }">{{ row.ctDate | fmtDate }}</template>
    </el-table-column>

    <TemplateDialog :entity="entity" @ok="page" :visible.sync="meta.template"></TemplateDialog>
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      TemplateDialog: () => import("./editor.vue"),
    },
    data() {
      return {
        isMine:false,
        date:null,
        meta: {
          loading: false,
          template: false,
        },
        entities: {},
        condition: {
          scope: "本人",
        },
        adviceEntitie: {},
        selectTempList: [],
        temData: {
          startTime: "",
        },
        rules: {
          startTime: [{ required: true, message: "请选择开始时间", trigger: "change" }],
        },
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "getDict", "dictEnum", "Enum", "permission", "user"]),
    },
    methods: {
      changeDate(d){
        if (d) {
          this.condition.createDateStart = this.$utils.Fmt.date(d[0]) + " 00:00:00";
          this.condition.createDateEnd = this.$utils.Fmt.date(d[1]) + " 23:59:59";
        } else {
          this.condition.createDateStart = null
          this.condition.createDateEnd = null
        }
        
        this.page()
      },
      page() {
        this.meta.loading = true;
        // console.log("======>",this.condition);
        this.condition.searchWord = this.condition.keyword
        delete this.condition.keyword
        if(this.isMine) this.condition.createUserId = this.user.code
        else delete this.condition.createUserId
        api.AdvicePackage.query(this.condition)
          .then((res) => {
            this.entities = res;
            this.entities.items.forEach(tmp => {
                if(!tmp.doctorCode) return
                api.Staff.get(tmp.doctorCode).then(staff=>{
                  this.$set(tmp,'doctorName',staff.name)
                })
            });           
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },

      edit(row) {
        this.entity = row ? this.$utils.Obj.clone(row) : null;
        this.meta.template = true;
      },
      del(row) {
        this.$confirm("确定要删除？", "警告", { type: "warning" })
          .then(() => {
            this.loading = true;
            api.AdvicePackage.del(row.id)
              .then((res) => {
                this.$message.success("删除成功!");
                this.page();
              })
              .catch((err) => {
                this.$message.error(err);
              });
          })
          .catch((e) => {});
      },
      info(row) {
        api.Hospitalization.get(row.hospitalizationId)
          .then((res) => {
            this.entity = res;
          })
          .catch((err) => {
            this.$message.error(err || err.message);
          })
          .finally((f) => {});
        this.value = this.$utils.Obj.clone(row);
        this.meta.info = true;
      },
      isMyTmpl(row){
        return row.doctorCode == this.user.code
      }
    },
  };
</script>

<style scoped></style>
